import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import {
  Menu,
  MenuItem,
  IconButton,
  CircularProgress,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { selectState, actionProps } from '../../../../../../utils/reduxActions';
import { lotsActions } from '../../../../reducer';
import { appActions } from '../../../../../../commons/reducer';
import connectSaga from '../../../../../../utils/saga';
import saga from '../../../../saga';
// ui
// icons
// utils
import { truthty, clone } from '../../../../../../utils/functions';
import { objectToQueryString } from '../../../../../../utils/api';

import { useTranslation } from 'react-i18next';

function ItemMenu(props) {
  const { t } = useTranslation();
  const {
    lot,
    actions,
    device,
    objects,
    history,
    controls: { lotIds },
    loading: traceabilityInProgress,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const loadingTraceability = traceabilityInProgress && lotIds.includes(lot.id.toString());

  const handleClick = (event) => {
    setAnchorEl(event.target);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const printFnc = () => {
    const labelData = { lotIds: [lot.id], accountId: Object.values(objects.accounts)[0]?.id };
    actions.printLabel(device, labelData);
  };

  const toggleWarehouseMovementForm = () => {
    actions.toggleWarehouseMovementForm(lot.id, objects.lots[lot.id]);
  };

  const handleMenuOnClick = (event) => {
    let query = `/process/${event.target.dataset.id}`;
    if (event.target.dataset.type === 'lotResume') {
      query = `lotResume?${objectToQueryString({ lotId: event.target.dataset.id })}`;
    }
    if (event.target.dataset.type === 'lotTraceability') {
      query = `lotTraceability?${objectToQueryString({ lotIds: [event.target.dataset.id] })}`;
    }

    history.push(query);
  };

  return (
    <>
      <IconButton onClick={handleClick} data-id={lot.id}>
        <MoreVertIcon data-id={lot.id} />
      </IconButton>
      {truthty(anchorEl) && Number(anchorEl.dataset.id) === lot.id && (
        <Menu anchorEl={anchorEl} keepMounted open={truthty(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={printFnc}>{t('Print')}</MenuItem>
          <MenuItem onClick={toggleWarehouseMovementForm} data-id={lot.destinyProcessId}>
            {t('Change warehouse')}
          </MenuItem>
          {truthty(lot.originProcessId) && (
            <MenuItem onClick={handleMenuOnClick} data-id={lot.originProcessId}>
              {t('Go to origin process')}
            </MenuItem>
          )}
          {truthty(lot.destinyProcessId) && (
            <MenuItem onClick={handleMenuOnClick} data-id={lot.destinyProcessId}>
              {t('Go to destination process')}
            </MenuItem>
          )}
          <MenuItem onClick={handleMenuOnClick} data-id={lot.id} data-type="lotResume">
            {t('Pak summary')}
          </MenuItem>
          <MenuItem
            onClick={handleMenuOnClick}
            data-id={lot.id}
            data-type="lotTraceability"
            disabled={loadingTraceability}>
            <ListItemText
              data-id={lot.id}
              data-type="lotTraceability"
              disableTypography
              primary={t('Traceability')}
            />
            {loadingTraceability && (
              <ListItemIcon>
                <CircularProgress size={14} />
              </ListItemIcon>
            )}
          </MenuItem>
        </Menu>
      )}
    </>
  );
}

const withSaga = connectSaga({ key: 'sagaLots', saga });

const withConnect = connect(
  selectState('app.objects', 'app.device', 'lotTraceability.controls', 'lotTraceability.loading'),
  actionProps(
    clone(clone.OBJECT, {
      printLabel: appActions.printLabel,
      toggleWarehouseMovementForm: lotsActions.toggleWarehouseMovementForm,
    }),
  ),
);

export default compose(withRouter, withConnect)(withSaga(ItemMenu));
